module.exports = __webpack_public_path__ + "static/img/smartControl3.8c934c40.png";